<script lang="ts" setup>
import { onMounted, reactive, ref } from 'vue'
import { validateComponent, ValidatorType } from '@/helper/ValidateDirective.ts'
import FormController from '@/controllers/FormController.ts'
import DhwTankSection from '@/components/steps/components/DhwTankSection.vue'
import BufferTankSection from '@/components/steps/components/BufferTankSection.vue'
import BackupHeaterSection from '@/components/steps/components/BackupHeaterSection.vue'

const validator: ValidatorType = reactive({})
const showExistingDhwCheckbox = ref(false)

const backupHeaterSectionComponent = ref<InstanceType<typeof BackupHeaterSection>>(null)
const dhwTankSectionComponent = ref<InstanceType<typeof DhwTankSection>>(null)
const bufferTankSectionComponent = ref<InstanceType<typeof BufferTankSection>>(null)

onMounted((): void => FormController.captureInitialData())

function validate(): boolean {
  const backupHeaterValid = backupHeaterSectionComponent?.value
    ? backupHeaterSectionComponent.value.validate()
    : true
  const dhwValid = dhwTankSectionComponent?.value
    ? dhwTankSectionComponent.value.validate()
    : true
  const bufferValid = bufferTankSectionComponent?.value
    ? bufferTankSectionComponent.value.validate()
    : true

  return backupHeaterValid
    && dhwValid
    && bufferValid
    && validateComponent(validator)
}

defineExpose({ validate, validator, })
</script>

<template>
  <div class="steps__content" data-hj-whitelist>
    <BackupHeaterSection
      ref="backupHeaterSectionComponent"
      :validator="validator"
      @change-existing-backup-heater-checkbox="value => showExistingDhwCheckbox = value"
    />

    <DhwTankSection
      ref="dhwTankSectionComponent"
      :show-existing-dhw-checkbox="showExistingDhwCheckbox"
      :validator="validator"
    />

    <BufferTankSection ref="bufferTankSectionComponent" :validator="validator" />
  </div>
</template>
